/**
 *  {
      "item_ref": "0010",
      "event_code": "EARN",
      "item_type": "privilege",
      "target": "instant",
      "coupons": [
        {
          "type": "multiplier",
          "logic": "[earn_amount] * 2",
          "qty": 1,
          "coupon_id": "coupon-38f1fe5bb5982c15e0c6ead8"
        }
      ],
      "tier_id": "tier-6003e816c2869603433f5c72"
    },
 */
class Tier {
  constructor({ id, name, desc, imageUrl, condition, privileges }) {
    this.id = id;
    this.name = name;
    this.desc = desc;
    this.imageUrl = imageUrl;
    this.privileges = privileges;
    this.condition = condition;
  }

  getPassConditionPrivileges(items) {
    //Assume with only two type of conditions which are payment and qty

    const { paid, qty } = items.reduce(
      (total, item) => {
        return {
          paid: total.paid + (item.chargeAmount ?? 0) * item.qty,
          qty: total.qty + (item.qty ?? 0),
        };
      },
      { paid: 0, qty: 0 }
    );
    const isEmptyObject = (obj) =>
      obj && // 👈 null and undefined check
      Object.keys(obj).length === 0 &&
      obj.constructor === Object;

    const result = this.privileges.filter((privilege) => {
      //All three if are for condition = {}
      if (!privilege.condition) {
        return true; //No condition
      }
      if (isEmptyObject(privilege.condition)) return true;

      if (JSON.stringify(privilege.condition) === "{}") {
        return true;
      }
      //May use LOGIC instead
      if (privilege.condition?.type === "qty") {
        return qty >= privilege.condition.value;
      }
      //May use LOGIC instead
      if (privilege.condition?.type === "paid") {
        return paid >= privilege.condition.value;
      }
      if (privilege.condition?.type) {
        //IN case no condition type assume as value
        return paid >= privilege.condition.value;
      }
      return false;
    });

    return result;
  }

  getPayloadData(pricebeforeDiscount) {
    const itemRef = "TIER001";
    return {
      item_ref: itemRef,
      event_code: "EARN",
      item_type: "privilege",
      target: "instant",
      coupons:
        this.privileges.coupons.map((coupon) =>
          coupon.getPayloadData(pricebeforeDiscount)
        ) ?? [],
      tier_id: this.id,
    };
  }
}

export default Tier;
